<template>
    <div class="create-tag" v-if="showCreateTag">
        <el-button type="primary" size="large" @click="createimage" style="background-color: #2a66ff;">生成生产图</el-button>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { ElIcon, ElInput, ElButton, ElPagination, ElEmpty, ElMessageBox, ElLoading } from 'element-plus'
import { useSdkStore } from '@/stores/sdk'
import { makeCustomizedImages } from '@/api/affairs'
import { useMiscStore } from "@/stores/misc";
const miscStore = useMiscStore()
const sdkStore = useSdkStore()
const showCreateTag = ref(false)
const desginsdk = sdkStore.getSdk()
onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const admin_id = urlParams.get('design_admin_id')
    if (admin_id) {
        showCreateTag.value = true
    }
})
const createimage = () => {
    const loadingInstance = ElLoading.service({
        lock: true,
        text: '生成中...',
        background: 'rgba(0, 0, 0, 0.2)'
    })
    ElMessageBox.confirm(
        '确定要生成生产图吗？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(async () => {
        desginsdk.designOpt.saveTemplate()
        const urlParams = new URLSearchParams(window.location.search)
        const id = urlParams.get('id') as string
        const admin_id = urlParams.get('design_admin_id') || '0'
        let params = {
            id: id,
            admin_id: admin_id,
            json_url: miscStore.getOssURL(),
        }
        setTimeout(async () => {
            await makeCustomizedImages(params)
            loadingInstance.close()
            window.close()
        }, 1000)
    }).catch(() => {
        loadingInstance.close()
    })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.create-tag {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
